export default function Navbar ( {darkMode, switchColourMode} ) {

    function ColourIcon () {
        return darkMode ? <i className="fa-regular fa-sun" /> : <i className="fa-regular fa-moon" />;
    }

    function scrollTo (sectionId) {
        document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <div className="flex m-4 justify-between items-center">
            <div className="icon w-16 h-16 rounded-[50%] border-2 p-2 flex items-center select-none">
                DM
            </div>
            <div className="flex items-center justify-around">
                <button className="small-p mr-2 hover:underline underline-offset-4" onClick={() => scrollTo("experience")}>My Experience</button>
                <button className="small-p mr-2 hover:underline underline-offset-4" onClick={() => scrollTo("projects")}>My App Projects</button>
                <button className="mr-2" onClick={() => switchColourMode()}>
                    <ColourIcon />
                </button>
                <a href="https://www.linkedin.com/in/domenicmarchese/" target={'_blank'} rel={'noreferrer'}>
                    <i className={`fa-brands fa-linkedin mr-2`}/>
                </a>
                <a href="https://github.com/marchesed" target={'_blank'} rel={'noreferrer'}>
                    <i className={`fa-brands fa-github mr-2`}/>
                </a>
            </div>
        </div>
    )
}